var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"427px"}},[_c('sidebar-lists',{staticClass:"mb-3"}),_c('sidebar-search',{staticClass:"mb-3 sidebar-rounded"}),_c('sidebar-contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }